import { WL_PRODUCT_QUERY_STRING } from '../../stores/constants';

export const getUrl = (): string => window.location.href;

export const addQueryParameterToURL = (
    continueToURL: string,
    parameterName: string,
    parameterValue: string,
): string => {
    let url = continueToURL;
    const queryParams = window.location.search;
    // this needs the undefined check for the tests which do not return search
    if (!queryParams || (queryParams && !queryParams.includes(parameterName))) {
        url += (url.split('?')[1] ? '&' : '?') + parameterName + '=' + parameterValue;
    }

    return url;
};

export const navigate = (location: string): void => {
    // Not user supplied input
    // nosemgrep
    window.location.href = location;
};

export const redirectToSignIn = (productId?: string, mode?: string): void => {
    const continueToURL = getUrl();
    let continueToURLWithQueryParams = undefined;
    if (mode === 'icon-placeholder-pdp' || mode === 'icon-placeholder-basket') {
        continueToURLWithQueryParams = productId
            ? addQueryParameterToURL(continueToURL, WL_PRODUCT_QUERY_STRING, productId)
            : addQueryParameterToURL(continueToURL, 'wishlist', 'interacted');
    } else {
        continueToURLWithQueryParams = productId
            ? addQueryParameterToURL(continueToURL, WL_PRODUCT_QUERY_STRING, productId) + `#${productId}`
            : addQueryParameterToURL(continueToURL, 'wishlist', 'interacted');
    }
    const locationURL = `${process.env.REACT_APP_BASE_REDIRECT_URL}/sign-in?continueTo=${window.encodeURIComponent(
        continueToURLWithQueryParams,
    )}`;

    navigate(locationURL);
};
